import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "./api/api";
import axios from "axios";
import { V1_BASE_URL } from "./api/bases";

const HelloDev = () => {
  const { filename } = useParams();
  const [examData, setExamData] = useState(null);

  const fetchData = async () => {
    try {
      const response = await axios.post(`${V1_BASE_URL}/v1/9928/imaging/get-image/id`, {
        row_id: filename,
      });

      if (response?.data?.data[0]) {
        const raw = response.data?.data[0];
        const parsedData = JSON.parse(raw.data);
        setExamData({
          exam: raw.exam,
          date: raw.dateofservice,
          patient: parsedData.pat_name,
          age: parsedData.pat_age,
          gender: parsedData.pat_gender,
          provider: parsedData.providername,
          history: parsedData.pathistory,
          impression: parsedData.sonographersImpression,
        });
      }
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  useEffect(() => {
    if (filename) fetchData();
  }, [filename]);

  return (
    <div className="p-4 flex justify-center items-center min-h-screen bg-gray-50">
      <div
        className="w-full max-w-md bg-white rounded-xl shadow-md p-6 border border-gray-200"
        id={examData ? "report-ready" : undefined} // 👈 Set id only when data is ready
      >
        <h2 className="text-lg font-semibold mb-4 text-blue-700">Exam Summary</h2>
        {examData ? (
          <div className="space-y-2 text-sm text-gray-700">
            <div><span className="font-medium">Exam:</span> {examData.exam}</div>
            <div><span className="font-medium">Date:</span> {examData.date}</div>
            <div><span className="font-medium">Patient:</span> {examData.patient}</div>
            <div><span className="font-medium">Age/Gender:</span> {examData.age} / {examData.gender}</div>
            <div><span className="font-medium">Provider:</span> {examData.provider}</div>
            <div><span className="font-medium">History:</span> {examData.history}</div>
            <div><span className="font-medium">Impression:</span> {examData.impression}</div>
          </div>
        ) : (
          <p className="text-gray-500">Loading...</p>
        )}
      </div>
    </div>
  );
};

export default HelloDev;
